import { render, staticRenderFns } from "./ProductsList.vue?vue&type=template&id=059920ce&"
import script from "./ProductsList.vue?vue&type=script&lang=ts&"
export * from "./ProductsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports